// src/pages/support/components/MemberRow.jsx
import React from "react";
import Badge from "./Badge";

function MemberRow({
  member,
  onDeactivatePlayer,
  onRollbackTransfer,
  onAddInstrument,
}) {
  const username = member?.user?.username || member?.user?.email || "—";
  const firstLetter = (username?.[0] || "U").toUpperCase();
  const isCaptain = (member?.role || "").toLowerCase() === "captain";
  const isActive = member?.is_active;

  // استخراج اطلاعات ساز
  const instrumentName = member?.instrument?.instrument?.instrument || null;
  const hasInstrument = !!instrumentName;

  return (
    <div
      className="rounded-xl border p-3 flex items-center gap-4"
      style={{
        borderColor: "rgba(55,65,81,0.5)",
        backgroundColor: "rgba(31,41,55,0.55)",
      }}
    >
      <div
        className="w-11 h-11 rounded-xl flex items-center justify-center text-white font-bold ring-1"
        style={{
          background: isCaptain
            ? "linear-gradient(135deg, rgba(253,224,71,0.25), rgba(253,224,71,0.08))"
            : "rgba(255,255,255,0.06)",
        }}
      >
        {firstLetter}
      </div>

      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2 flex-wrap">
          <span className="text-white font-semibold truncate">{username}</span>
          {isCaptain && (
            <Badge
              color="#fde047"
              bg="rgba(253,224,71,0.15)"
              border="rgba(253,224,71,0.35)"
            >
              کاپیتان
            </Badge>
          )}
          {isActive ? (
            <Badge>فعال</Badge>
          ) : (
            <Badge
              color="#ef4444"
              bg="rgba(239,68,68,0.15)"
              border="rgba(239,68,68,0.35)"
            >
              غیرفعال
            </Badge>
          )}
          {/* نمایش ساز */}
          {hasInstrument && (
            <Badge
              color="#3b82f6"
              bg="rgba(59,130,246,0.15)"
              border="rgba(59,130,246,0.35)"
            >
              {instrumentName}
            </Badge>
          )}
        </div>

        <div className="text-[11px] text-gray-400 mt-1 flex flex-wrap gap-x-3 gap-y-1">
          {member?.joined_at && (
            <span>
              پیوستن: <span className="text-gray-300">{member.joined_at}</span>
            </span>
          )}
          {member?.left_at && (
            <span>
              ترک: <span className="text-gray-300">{member.left_at}</span>
            </span>
          )}
          {hasInstrument && (
            <span>
              نماد:{" "}
              <span className="text-blue-300 font-semibold">
                {instrumentName}
              </span>
            </span>
          )}
        </div>
      </div>

      <div className="flex gap-2 flex-shrink-0">
        {/* دکمه افزودن/تغییر ساز */}
        <button
          onClick={() => onAddInstrument(member.user_id, username)}
          className="px-3 py-1.5 rounded-lg text-xs text-white hover:opacity-90"
          style={{ backgroundColor: hasInstrument ? "#3b82f6" : "#10b981" }}
          title={hasInstrument ? "تغییر نماد" : "افزودن نماد"}
        >
          {hasInstrument ? "🔄 تغییر نماد" : "➕ نماد"}
        </button>

        <button
          onClick={() => onRollbackTransfer(member.user_id, username)}
          className="px-3 py-1.5 rounded-lg text-xs text-white hover:opacity-90"
          style={{ backgroundColor: "#8b5cf6" }}
          title="بازگشت انتقال"
        >
          ↩ Rollback
        </button>

        {isActive && (
          <button
            onClick={() => onDeactivatePlayer(member.user_id, username)}
            className="px-3 py-1.5 rounded-lg text-xs text-white hover:opacity-90"
            style={{ backgroundColor: "#f59e0b" }}
            title="غیرفعال کردن بازیکن"
          >
            غیرفعال
          </button>
        )}
      </div>
    </div>
  );
}

export default MemberRow;
